import { Component, input, output } from '@angular/core';
import { InputFilterWithHeaderComponent } from '@vectronic/ui';

@Component({
  selector: 'table-datatable-filter-input',
  templateUrl: './datatable-filter-input.component.html',
  imports: [InputFilterWithHeaderComponent],
})
export class DatatableFilterInputComponent {
  title = input.required<string>();
  value = input<any>();
  valueChange = output<any>();
  options = input<(str: string) => any>();
  placeholder = input('');
  tooltip = input('');
}
